import { GetTotalInput, GetTotalInput_Answer, GetTotalInput_Question, QuestionType, Questions } from "models";
import { COMPANIES_SELECTION_QUESTION, SurveyUtility } from "./survey";
import { BrowserConfig } from "src/_services";

export class TotalsUtility {

    static getTotalInput(fQuestions: Questions): GetTotalInput {
      const input: GetTotalInput = new GetTotalInput();
      input.UserDateOfBirth = new Date("1970-06-30"); // Valore settato temporaneamente
      input.UserId = "abc"; // Valore settato temporaneamente
      input.Version = "V1"; // Valore settato temporaneamente
      input.Questions = [];
      input.TestMode = false;

      // 1.0
      let _first = new GetTotalInput_Question('1.0');
      _first.Answers = [new GetTotalInput_Answer('1.0')];
      input.Questions.push(_first);

      if(fQuestions != null) {
        fQuestions.forEach((q, i) => {

          if (i == 0 || !SurveyUtility.isQuestionHidden(q, fQuestions)) {

            let newQItem = new GetTotalInput_Question(q.id);
            newQItem.Answers = [];
            let newAnswer = new GetTotalInput_Answer(null);
            let isPushAnswer = false;
            
              q.answers.forEach(a => {
                if(a.isSelected) {
    
                  newAnswer.Code = a.id;
  
                  if(q.id == COMPANIES_SELECTION_QUESTION) {
                    newAnswer.Value1 = a.value1;
                  }
                  else {
                    switch(q.type) {
                      case QuestionType.SingleValue:
                        newAnswer.Value1 = a.value1;
                        // Nella domanda viene chiesto di inserire il riscatto in anni,
                        // ma lato backend viene gestito in mesi,
                        // pertanto, è necessario moltiplicare il valore inserito per 12
                        if (q.id == BrowserConfig.redemptionQuestion) {
                          newAnswer.Value1 = (parseInt(newAnswer.Value1) * 12).toString();
                        }
                        break;
      
                      case QuestionType.MultipleAnswerCheck: 
                        newAnswer.Code = q.id;
                        if(newAnswer.Value1 == null) { newAnswer.Value1 = ''; }
                        newAnswer.Value1 += `${ newAnswer.Value1 != '' ? ',' : '' }${a.text}`;
                        break;
                      
                      case QuestionType.Range:
                      case QuestionType.RangeSlider:
                        newAnswer.Value1 = a.value1;
                        newAnswer.Value2 = a.value2;
                        break;
                    }
                  }
    
                  isPushAnswer = true;
                }
              });
  
            if(isPushAnswer) { newQItem.Answers.push(newAnswer); }
  
            if(newQItem.Answers?.length > 0) {
                input.Questions.push(newQItem);
            }
          }




  
          let dependentQ: GetTotalInput_Question;
          if(q.dependentOn != null) {
            dependentQ = input.Questions.find(x => x.Code == q.dependentOn.split('-')[0]);
          }
          if(q.dependentOn == null || dependentQ?.Answers.find(x => x.Code == q.dependentOn) != null) {
  
          }
  
        })
      }

      return input
    }

}